import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';

export default {
  async pdfGenerator(data) {
    // eslint-disable-next-line
    const purchaseOrder = new jsPDF();
    console.log('pdf datum: ', data);
    purchaseOrder.text('Hello World', 10, 10);
    purchaseOrder.save('test.pdf');
  },
};
